module.exports = __webpack_public_path__ + "static/media/no-friends.6d5d5ef7.svg";